import React from 'react';

export const Card: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className = '',
  children,
  ...rest
}) => (
  <div
    {...rest}
    className={[
      'bg-white border border-sand-200 rounded-2xl shadow-card',
      className,
    ].join(' ')}
  >
    {children}
  </div>
);

interface StatCardProps {
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
  tone?: 'default' | 'accent' | 'sage';
}

export const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  icon,
  tone = 'default',
}) => {
  const valueColor =
    tone === 'accent'
      ? 'text-terracotta-600'
      : tone === 'sage'
      ? 'text-sage-700'
      : 'text-sand-900';
  const iconBg =
    tone === 'accent'
      ? 'bg-terracotta-50 text-terracotta-600'
      : tone === 'sage'
      ? 'bg-sage-50 text-sage-700'
      : 'bg-sand-100 text-sand-600';

  return (
    <Card className="p-4 flex items-center gap-4">
      {icon && (
        <div
          className={[
            'shrink-0 w-11 h-11 rounded-xl flex items-center justify-center',
            iconBg,
          ].join(' ')}
        >
          {icon}
        </div>
      )}
      <div className="min-w-0">
        <p className="text-xs font-medium text-sand-500 tracking-wide">
          {label}
        </p>
        <p className={['text-xl font-semibold mt-0.5', valueColor].join(' ')}>
          {value}
        </p>
      </div>
    </Card>
  );
};

export const SectionLabel: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className = '' }) => (
  <p
    className={[
      'text-[11px] font-medium text-sand-500 uppercase tracking-wider',
      className,
    ].join(' ')}
  >
    {children}
  </p>
);
